export const additionalCategoryAPIs = {
  add: {
    url: 'categoryAdditions',
    method: 'post',
    isAuthEnabled: true,
  },
  get: {
    url: 'categoryAdditions',
    method: 'get',
    isAuthEnabled: true,
  },
  getAll: {
    url: 'categoryAdditions/all',
    method: 'get',
    isAuthEnabled: true,
  },
  delete: {
    url: 'categoryAdditions',
    method: 'delete',
    isAuthEnabled: true,
  },
  update: {
    url: 'categoryAdditions',
    method: 'patch',
    isAuthEnabled: true,
  },
  deleteAddition: {
    url: 'additions',
    method: 'delete',
    isAuthEnabled: true,
  },
};
